import React from "react";
import { motion } from "framer-motion";
import { ABOUT } from "../lib/data";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="md:col-span-4"
        >
          <p className="overline text-primary mb-4">About</p>
          <h2 className="font-serif text-3xl md:text-4xl leading-tight text-foreground">
            {ABOUT.lead}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="md:col-span-7 md:col-start-6"
        >
          <div className="space-y-5 text-lg text-foreground/70 leading-relaxed">
            {ABOUT.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-black/5 pt-8">
            {ABOUT.stats.map((s) => (
              <div key={s.label} data-testid="about-stat">
                <div className="font-serif text-4xl md:text-5xl text-primary">{s.value}</div>
                <div className="mt-2 text-sm text-foreground/60">{s.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
